
import { post } from './client';

export const postWav = (wavData) => {
    return post(wavData)
        .then(res => {
            return res.data;
        });
};
